import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { Title } from '@angular/platform-browser';

import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';

@Component({
    selector: 'app-subscription-reporting-applications',
    templateUrl: './subscription-reporting-applications.component.html',
    providers: [Title]
})
export class SubscriptionReportingApplicationsComponent implements OnInit {

    mychart1: boolean = true;
    //mychart2: boolean = true;
    //mychart3: boolean = true;

    constructor(private title: Title, private router: Router) {
        this.title.setTitle('Dashboard - Applications | XYZ Corp. Verification Workspace');
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });

        this.refreshChart1();
        //this.refreshChart2();
        //this.refreshChart3();

    }

    ///////////////////////////////////////// SHARED OPTIONS ///////////////////////////////////////////////////
    public legendTrue: boolean = true;
    public legendFalse: boolean = false;
    public chartTypeBar: string = 'bar';
    public chartTypeDoughnut: string = 'doughnut';
    public chartTypePolarArea: string = 'polarArea';
    public chartTypeLine: string = 'line';

    // Weekly Application Volumes   
    public weeklyApplicationVolumesOptions: any = {
        scaleShowVerticalLines: false,
        legend: {
            position: 'bottom',
            labels: {
                usePointStyle: true
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [{
                stacked: false,
                scaleLabel: {
                    display: true,
                    labelString: 'Number of Applications',
                    fontSize: '14',
                    fontStyle: 'bold'
                },
                ticks: {
                    beginAtZero: true
                    //callback: function (label, index, labels) {
                    //    return label / 1000 + 'k';
                    //}
                }
            }],
            xAxes: [{
                stacked: false,
                scaleLabel: {
                    display: true,
                    labelString: 'Last 14 Days',
                    fontSize: '14',
                    fontStyle: 'bold'
                },
                ticks: {
                    beginAtZero: true
                },
                gridLines: {
                    display: false
                }
            }]
        }
    };

    public weeklyApplicationVolumesLabels: string[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14'];

    // Holders Matched By Chart    
    public projectSplitOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        legend: {
            position: 'bottom',
            display: true,
            labels: {
                usePointStyle: true
            }
        }
    };

    public offersLabels: string[] = ['Offer 1', 'Offer 2', 'Offer 3', 'Offer 4', 'Offer 5', 'Offer 6'];

    // Holders Matched By Chart    
    public doughnutChartOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        legend: {
            position: 'bottom',
            display: true,
            labels: {
                usePointStyle: true
            }
        }
    };

    public newVersusReturningLabels: string[] = ['Cash', 'Leveraged'];
    public paymentMethodsLabels: string[] = ['ACH', 'Check', 'Wire'];

    // PolarArea
    public applicationsPolarAreaOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            position: 'bottom',
            labels: {
                usePointStyle: true
            }
        },
        scales: {
            yAxes: [{
                display: false
            }],
            xAxes: [{
                display: false
            }]
        },
        layout: {
            padding: {
                top: 10
            }
        }
    };

    public applicantProfileLabels: string[] = ['Existing', 'New', 'Registered Only'];

    public applicationsByCountryOptions: any = {
        scaleShowVerticalLines: false,
        legend: {
            position: 'bottom',
            labels: {
                usePointStyle: true
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [{
                stacked: false,
                scaleLabel: {
                    display: true,
                    labelString: 'Number of Applications',
                    fontSize: '14',
                    fontStyle: 'bold'
                },
                ticks: {
                    beginAtZero: true,
                    callback: function (label, index, labels) {
                        return label / 1000 + 'k';
                    }
                }
            }],
            xAxes: [{
                stacked: false,
                scaleLabel: {
                    display: true,
                    labelString: 'State',
                    fontSize: '14',
                    fontStyle: 'bold'
                },
                ticks: {
                    beginAtZero: true
                },
                gridLines: {
                    display: false
                }
            }]
        }
    };

    public applicationsByCountryLabels: string[] = ['TX', 'CO', 'FL', 'WA', 'OH', 'CA'];

    public weeklyApplicationVolumesAllData: any[] = [
        { data: [523, 658, 998, 1000, 874, 687, 125, 745, 357, 411, 542, 985, 547, 852, 149], label: 'Existing' },
        { data: [325, 415, 822, 841, 984, 888, 685, 741, 854, 687, 234, 541, 874, 147, 841], label: 'New' },
        { data: [124, 213, 342, 432, 235, 98, 123, 341, 233, 543, 111, 222, 235, 123, 111], label: 'Registered Only' }
    ];
    public weeklyApplicationVolumesOffer1Data: any[] = [
        { data: [223453, 216123, 170324, 144789, 267123, 245543, 190435, 210343, 234123, 198456, 98123, 212456, 111567, 453432, 123451], label: 'Offer 1' }
    ];
    public weeklyApplicationVolumesOffer2Data: any[] = [
        { data: [342345, 178389, 165098, 190434, 212342, 267167, 221678, 175648, 211345, 241876, 134432, 156444, 87567, 324343, 216453], label: 'Offer 2' }
    ];
    public weeklyApplicationVolumesOffer3Data: any[] = [
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Offer 3' }
    ];
    public weeklyApplicationVolumesOffer4Data: any[] = [
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Offer 4' }
    ];
    public weeklyApplicationVolumesOffer5Data: any[] = [
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Offer 5' }
    ];
    public weeklyApplicationVolumesOffer6Data: any[] = [
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Offer 6' }
    ];

    public newVersusReturningAllData: number[] = [10556, 6224];
    public newVersusReturningOffer1Data: number[] = [8523, 1899];
    public newVersusReturningOffer2Data: number[] = [3975, 2383];
    public newVersusReturningOffer3Data: number[] = [0, 0];
    public newVersusReturningOffer4Data: number[] = [0, 0];
    public newVersusReturningOffer5Data: number[] = [0, 0];
    public newVersusReturningOffer6Data: number[] = [0, 0];

    public paymentMethodsAllData: number[] = [2678, 4828, 9124];
    public paymentMethodsOffer1Data: number[] = [1953, 2631, 5739];
    public paymentMethodsOffer2Data: number[] = [965, 1945, 3212];
    public paymentMethodsOffer3Data: number[] = [0, 0, 0];
    public paymentMethodsOffer4Data: number[] = [0, 0, 0];
    public paymentMethodsOffer5Data: number[] = [0, 0, 0];
    public paymentMethodsOffer6Data: number[] = [0, 0, 0];

    public applicantProfileAllData: number[] = [5521, 5433, 5826];
    public applicantProfileOffer1Data: number[] = [3156, 3299, 3967];
    public applicantProfileOffer2Data: number[] = [1986, 2876, 1496];
    public applicantProfileOffer3Data: number[] = [0, 0, 0];
    public applicantProfileOffer4Data: number[] = [0, 0, 0];
    public applicantProfileOffer5Data: number[] = [0, 0, 0];
    public applicantProfileOffer6Data: number[] = [0, 0, 0];

    public applicationsByCountryAllData: any[] = [
        { data: [10068, 1678, 2517, 839, 1342, 336], label: 'Applications' }
    ];
    public applicationsByCountryOffer1Data: any[] = [
        { data: [6253, 1042, 1563, 521, 833, 210], label: 'Applications' }
    ];
    public applicationsByCountryOffer2Data: any[] = [
        { data: [3814, 635, 953, 317, 508, 131], label: 'Applications' }
    ];
    public applicationsByCountryOffer3Data: any[] = [
        { data: [0, 0, 0, 0, 0, 0], label: 'Applications' }
    ];
    public applicationsByCountryOffer4Data: any[] = [
        { data: [0, 0, 0, 0, 0, 0], label: 'Applications' }
    ];
    public applicationsByCountryOffer5Data: any[] = [
        { data: [0, 0, 0, 0, 0, 0], label: 'Applications' }
    ];
    public applicationsByCountryOffer6Data: any[] = [
        { data: [0, 0, 0, 0, 0, 0], label: 'Applications' }
    ];

    //////////////////////////////////////////// COLOURS ///////////////////////////////////////////////////////
    public solidBackgroundColors = [
        {
            backgroundColor: ['rgba(67,91,115,1)', 'rgba(193,189,170,1)', 'rgba(224,216,174,1)', 'rgba(115,91,93,1)', 'rgba(112,114,112,1)', 'rgba(163,170,163,1)', 'rgba(128,109,141,1)', 'rgba(112,92,126,1)', 'rgba(146,114,166,1)']
        }
    ];

    public transparentBackgroundColors = [
        {
            backgroundColor: ['rgba(104,132,155,0.8)', 'rgba(188,201,210,0.8)', 'rgba(193,189,170,0.8)', 'rgba(224,216,174,0.8)', 'rgba(163,170,163,0.8)']
        }
    ];

    public lineChartColors = [
        {
            backgroundColor: 'rgba(67,91,115,0.05)',
            borderColor: 'rgba(67,91,115,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(67,91,115,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(67,91,115,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        },
        {
            backgroundColor: 'rgba(193,189,170,0.05)',
            borderColor: 'rgba(193,189,170,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(193,189,170,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(193,189,170,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        },
        {
            backgroundColor: 'rgba(224,216,174,0.05)',
            borderColor: 'rgba(224,216,174,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(224,216,174,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(224,216,174,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        },
        {
            backgroundColor: 'rgba(115,91,93,0.05)',
            borderColor: 'rgba(115,91,93,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(115,91,93,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(115,91,93,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        },
        {
            backgroundColor: 'rgba(112,114,112,0.05)',
            borderColor: 'rgba(112,114,112,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(112,114,112,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(112,114,112,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        },
        {
            backgroundColor: 'rgba(163,170,163,0.05)',
            borderColor: 'rgba(163,170,163,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(163,170,163,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(163,170,163,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        }
    ];

    // events
    public chartClicked(e: any): void {
        //console.log(e);
    }
    public chartHovered(e: any): void {
        //console.log(e);
    }

    refreshChart1() {
        this.mychart1 = false;
        setTimeout(() => {
            this.mychart1 = true;
        }, 1);
    }

    //refreshChart2() {
    //    this.mychart2 = false;
    //    setTimeout(() => {
    //        this.mychart2 = true;
    //    }, 1);
    //}

    //refreshChart3() {
    //    this.mychart3 = false;
    //    setTimeout(() => {
    //        this.mychart3 = true;
    //    }, 1);
    //}

    handleChange1(e) {
        this.refreshChart1();
    }

    //handleChange2(e) {
    //    this.refreshChart2();
    //}

    //handleChange3(e) {
    //    this.refreshChart3();
    //}

}
